import Masonry from 'masonry-layout';

import observe from './observe.js';
import breakpoints from '@utils/breakpoints.js';

const SELECTOR_CONTAINER = '.js-masonry-container';
const SELECTOR_ITEM = '.js-masonry-item';

const CLASSNAME_VISIBLE = 'is-visible';
const TIMEOUT = 800;
const GUTTER = 0;

const onResize = () => {
  const grid = document.querySelector(SELECTOR_CONTAINER);
  const isMobile = breakpoints.test(breakpoints.md);

  if (!grid) return;

  if (isMobile) {
    window.masonry && window.masonry.destroy();
  } else {
    if (!window.masonry) {
      window.masonry = new Masonry(grid, {
        itemSelector: SELECTOR_ITEM,
        gutter: GUTTER,
      });
    } else {
      window.masonry.reload();
    }
  }

  setTimeout(() => {
    [].forEach.call(
      grid.querySelectorAll(SELECTOR_ITEM),
      element => observe(element, ({ isIntersecting }) => {
        isIntersecting && element.classList.add(CLASSNAME_VISIBLE);
      })
    );
  }, TIMEOUT);
}

const init = () => {
  window.addEventListener('resize', onResize);
  onResize();
}

export default {
  init
}
